export default {
  'status': 'Translation validated by country',
  'meta': {
    'lang': 'Български'
  },
  'title': 'ИЗТЕГЛЯНЕ НА ПРОДУКТ ПРИМКА С КАРАБИНЕРИ ALPINISM И VERTIKA',
  'homepage': {
    'notice': 'Изтегляне на продукт. Важна информация относно Вашата безопасност и Вашето оборудване.',
    'purchaseWindow': 'Купили сте примка с карабинери Alpinism или Vertika в периода от 01.01.2022 г. до 23.07.2026 г.',
    'skus': 'Примка с карабинери Alpinism 11 cm (4051175 / 8589547)\n Примка с карабинери Alpinism 17 cm (4051176 / 8589548\n Комплект 5 бр. примки с карабинери Alpinism (4171656 / 8608405)\n Примка с карабинери Vertika 11 cm (5499689 / 8935765)\n Примка с карабинери vertika 17 cm (5500194 / 8935909)',
    'responsibility': 'Като производител на лични предпазни средства ние носим пълна отговорност към хората, които използват нашите продукти. В тази връзка Ви информираме за изтеглянето на продукта ПРИМКА С КАРАБИНЕРИ Rocky Fil.',
    'defect': 'Установихме дефект в нита на телената ключалка на част от карабинерите. Този производствен дефект може да причини счупване на ключалката, а при падане и счупване на самия карабинер.',
    'stopUsing': 'Като предпазна мярка Ви молим незабавно да преустановите използването на продукта и да следвате процедурата по-долу.'
  },
  'procedure': {
    'stopUsing': 'Молим Ви незабавно да преустановите използването на това оборудване и да проверите дали Вашият продукт е засегнат от този дефект, като следвате инструкциите по-долу.',
    'title': 'Проверете продукта си:',
    'intro': 'Проверете дали двата края на телената ключалка са здраво закрепени към карабинера:',
    'step1': 'Хванете карабинера от едната страна и поставете палеца си между двата тела (възможно най-близо до нита). Натиснете силно надолу спрямо тялото на карабинера.',
    'step2': 'Обърнете карабинера и повторете същото движение от другата страна на телената ключалка.'
  },
  'outcome': {
    'nok': {
      'body': 'След проверката телта излиза от гнездото си: Молим Ви да преустановите незабавно използването на продукта и да го върнете в най-близкия магазин DECATHLON. На място нашият екип ще приеме дефектния продукт и ще Ви възстанови пълната сума, заплатена за него.',
      'support': 'Нашият център за обслужване на клиенти е на Ваше разположение, за да отговори на всичките Ви въпроси на телефон 02 902 10 70 от понеделник до събота от 09:00 до 18:00 часа.'
    },
    'ok': {
      'body': 'След проверката телта НЕ излиза от гнездото си: Вашият продукт не е засегнат от този дефект, можете да продължите да го използвате напълно спокойно.'
    }
  },
  'buttons': {
    'ok': 'Продуктът е изправен',
    'nok': 'Продуктът е дефектен'
  }
} as const
